module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('strong', [_c('em', [_vm._v("Abbreviations")])])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("I. JOURNALS, PERIODICALS, REFERENCE WORKS, AND SERIES")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("AnBib")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Analecta biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("ANTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Abingdon New Testament Commentaries or Augsburg New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("APOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Apocrypha and Pseudepigrapha of the Old Testament,")]), _vm._v(" by R. H. Charles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BAG")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("W. Bauer, W. F. Arndt, and F. W. Gingrich, "), _c('em', [_vm._v("A Greek-English Lexicon of The New Testament and Other Early Christian Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BDF")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("F. Blass, A. Debrunner, and R. W. Funk, "), _c('em', [_vm._v("A Greek Grammar of the New Testament and Other Early Christian Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BETL")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Bibliotheca ephemeridum theologicarum lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BFCT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Beiträge zur Förderung christlicher Theologie")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Black’s New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Bibliotheca sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BTN")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Biblica Theologica Norvegica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("CBSC")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Cambridge Bible for Schools and Colleges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("CEJL")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Commentaries on Early Jewish Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("CGTSC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Cambridge Greek Testament for Schools and Colleges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("ConNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Coniectanea biblica: New Testament Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("DLNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Dictionary of the Later New Testament and Its Developments")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("DPL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Dictionary of Paul and His Letters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("EB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Etudes bibliques")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("EKK")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Evangelische-katholischer Kommentar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("ExpT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("HNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Handbuch zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("HTKNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Herders theologischer Kommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("JNES")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of Near Eastern Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("JSJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal for the Study of Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("L&S")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. D. Liddell and R. Scott, "), _c('em', [_vm._v("A Greek-English Lexicon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("MNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Moffatt New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("MSGVK")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Mitteilungen der schlesischen Gesellschaft für Volkskunde")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NCB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New Century Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NIBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NIGTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Greek Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Novum Testamentum Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NTD")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Das Neue Testament Deutsch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("OTP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Old Testament Pseudepigrapha,")]), _vm._v(" edited by James H. Charlesworth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("SB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Sources bibliques")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("SBLSCS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Society of Biblical Literature Septuagint and Cognate Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Scr")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Scripture")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("SD")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Studies and Documents")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("ST")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Studia Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("SVTP")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Studia in Veteris Testamenti pseudepigrapha")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("TLZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theologische Literaturzeitung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("TNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tyndale New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("TU")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Texte und Untersuchungen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("TZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("WTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Westminster Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("II. BIBLE TRANSLATIONS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("ASV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("American Standard Version (1901)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("ESV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("English Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("GNB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Good News Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("JB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("KJV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Septuagint, i.e. the main Greek translation of the Hebrew Scriptures")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NAB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New American Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NASV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New American Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NET Bible")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New English Translation (©1996, Biblical Studies Press)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NKJV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NLV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New Living Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("RV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("English Revised Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("TEV")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Today’s English Version (1966)")])])])])])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('strong', [_vm._v("III. APOCRYPHA")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Because they are part of the Septuagint, and thus part of the Bible of the early Jesus movement, the Apocrypha are cited in the same manner as any other biblical book.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1 Esdr")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("First Esdras")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("2 Esdr")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Second Esdras")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Jdt")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Judith")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1 Macc")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("First Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("2 Macc")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Second Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("3 Macc.")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Third Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4 Macc.")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Fourth Maccabees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Sir")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Sirach, or the Wisdom of Jesus ben Sira, or Ecclesiasticus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tob")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tobit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Wisd")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Wisdom of Solomon")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("IV. PSEUDEPIGRAPHA")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("A")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ikar")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("A")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("iqar (The Words of A")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("iqar) or A")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ikar")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("1 Enoch")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("First (Ethiopic) Enoch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("2 Enoch")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Second (Slavonic) Enoch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("2 Apoc. Bar.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Second Apocalypse of Baruch")]), _vm._v(" (also called "), _c('em', [_vm._v("2 Bar.")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("3 Apoc. Bar.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Third Apocalypse of Baruch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Asc. Isa.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Ascension of Isaiah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("4 Ezra")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Fourth Ezra")]), _vm._v(" (an expanded form of 2 Esdr)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Jub.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Jubilees")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Paral. Jer.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Paraleipomena Jeremiou")]), _vm._v(" ("), _c('em', [_vm._v("Things Omitted from Jeremiah,")]), _vm._v(" also known as "), _c('em', [_vm._v("4 Bar.")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Pss. Sol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Psalms of Solomon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Sib. Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Sibylline Oracles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Test. Abr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Abraham")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Test. Moses")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Moses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("T. Ash.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Asher")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("T. Benj.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Benjamin")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("T. Jud.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Judah")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('em', [_vm._v("T. Levi")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Levi")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("T. Naph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Naphtali")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("T. Reub.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Reuben")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("T. Zeb.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testament of Zebulun")]), _vm._v(" in the "), _c('em', [_vm._v("Testaments of the Twelve Patriarchs")])])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("V. DEAD SEA SCROLLS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QapGen")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The "), _c('em', [_vm._v("Genesis Apocryphon")]), _vm._v(" from Cave 1 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QH")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The "), _c('em', [_vm._v("Thanksgiving")]), _vm._v(" scroll from Cave 1 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QM")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The "), _c('em', [_vm._v("War")]), _vm._v(" scroll from Cave 1 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QpHab")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Commentary (Pesher) on Habakkuk")]), _vm._v(" from Cave 1 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QPs"), _c('sup', [_vm._v("a")]), _vm._v("Zion")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Psalms of Zion")]), _vm._v(" scroll from Cave 1 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QS")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The "), _c('em', [_vm._v("Rule of the Community")]), _vm._v(" from Cave 1 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("1QSa")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The "), _c('em', [_vm._v("Rule of the Congregation")]), _vm._v(" or "), _c('em', [_vm._v("Messianic Rule")]), _vm._v(" from Cave 1 of Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QAmram")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The scroll about Amram from Cave 4 of Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QEn"), _c('sup', [_vm._v("a")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QEnoch"), _c('sup', [_vm._v("a")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QEn"), _c('sup', [_vm._v("c")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QEnoch"), _c('sup', [_vm._v("c")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QEnGiants"), _c('sup', [_vm._v("a")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Aramaic Fragments of "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" from the "), _c('em', [_vm._v("Book of Giants")]), _vm._v(" from Cave 4 of Qumran (4Q203)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QFlor")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Florilegium")]), _vm._v(" from Cave 4 of Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QpNah")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Commentary (Pesher) on Nahum")]), _vm._v(" from Cave 4 in Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("4QTest [4Q175]")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Testimonia")]), _vm._v(" from Cave 4 of Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Cairo "), _c('em', [_vm._v("Damascus Document")])])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("VI. RABBINIC WRITINGS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("m. Abot")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Mishnah")]), _vm._v(" tractate "), _c('em', [_vm._v("Abot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("m. Sanh.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Mishnah")]), _vm._v(" tractate "), _c('em', [_vm._v("Sanhedrin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("m. Sot.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Mishnah")]), _vm._v(" tractate "), _c('em', [_vm._v("Sotah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("b. B. Bat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Baba Bathra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("b. Hag.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Hagigah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('em', [_vm._v("b. Kidd.")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Kiddushin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("b. Menah.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Menahoth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("b. Mes")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ia")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Mes")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("b. Sanh.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Sanhedrin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("b. Yoma")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Babylonian Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Yoma")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("y. Ta")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("an.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Jerusalem Talmud,")]), _vm._v(" tractate "), _c('em', [_vm._v("Ta")]), _c('span', {
    staticClass: "char"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("anit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Gen. R.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Genesis Rabba")]), _vm._v(" (the great midrash on Genesis)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Lev. R.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Leviticus Rabba")]), _vm._v(" (the great midrash on Leviticus)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Num. R.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Numbers Rabba")]), _vm._v(" (the great midrash on Numbers)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Pirqe R. El.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Pirqe de Rabbi Eliezer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Sifré Num.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Sifré on Numbers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Tg. Neof.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Targum Neofiti")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Tg. Ps.-J.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Targum Pseudo-Jonathan")])])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("VII. JEWISH WRITERS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Josephus")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Flavius Josephus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Jewish Antiquities")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("C. Ap.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Contra Apion (Against Apion)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Life")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Life of Flavius Josephus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("War")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Jewish War")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Philo")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Philo Judaeus of Alexandria,")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Abr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De Abrahamo (Abraham)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Aet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De aeternitate mundi (On the Eternity of the World)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Cher.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De cherubim (on the Cherubim)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Conf.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De confusione linguarum (On the Confusion of Tongues)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Cong.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De congressu quaerendae eruditionis gratia (On Mating with the Preliminary Studies)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Decal.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De decalogo (On the Decalogue)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Ebr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De ebrietate (On Drunkenness)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Fug. et inv.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De fuga et inventione (On Flight and Finding)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Leg. alleg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Legum allegoriae (Allegorical Interpretation)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Migr. Abr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De migratione Abrahami (On the Migration of Abraham)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Mut.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De mutatione nominum (On the Change of Names)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Opif. mundi")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De opificio mundi (On the Creation)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Plant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De plantatione (Concerning Noah’s Work as a Planter)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Post. Caini")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De posteritati Caini (Descendants of Cain)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('em', [_vm._v("Quaest. Gen.")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Questiones et solutiones in Genesin (Questions and Answers on Genesis)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Quis her.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Quis rerum divinarum heres (Who Is the Heir of Divine Things)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Sacr. Abel")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De sacrificiis Abelis et Cain (On the Sacrifices of Abel and Cain)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Somn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De somniis (On Dreams)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Spec. leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De specialibus legibus (The Special Laws)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Vit. Mos.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De vita Moses (Life of Moses)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Pseudo-Philo")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The "), _c('em', [_vm._v("Biblical Antiquities")]), _vm._v(" of Pseudo-Philo")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Bib. Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  })])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("VIII. EARLY CHRISTIAN WRITINGS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Acts Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Acts of Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Apoc. Paul")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Apocalypse of Paul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Barn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Epistle of Barnabas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("1 Clem.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("First Epistle of Clement to the Corinthians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("2 Clem.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Second Epistle of Clement to the Corinthians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Clement of Alexandria")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Clement of Alexandria")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Clem. Hom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Pseudo-Clementine Homilies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Did.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Didache (Teaching of the Twelve Apostles)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Diogn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Letter of Diognetus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Ep. Apost.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Epistle of the Apostles (Epistula Apostolorum)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Eusebius")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Eusebius")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Eccl. Hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Ecclesiastical History.")]), _vm._v(" In some works abbreviated as "), _c('em', [_vm._v("H.E.")]), _vm._v(" or cited as "), _c('em', [_vm._v("Church History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Gnostic writings")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Corp. Herm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Corpus Hermeticum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("G. Thomas")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Gospel of Thomas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Testim. Truth")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Testimony of Truth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Treat. Seth")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Second Treatise of the Great Seth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Hermas")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The Shepherd of Hermas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Man.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Mandate")]), _vm._v(" or "), _c('em', [_vm._v("Command")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Sim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Similitude")]), _vm._v(" or "), _c('em', [_vm._v("Parable")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Vis.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Vision")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Hippolytus")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Hippolytus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Apos. Trad.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Apostolic Tradition")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("Ignatius")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Ignatius")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Eph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Letter of Ignatius to the Church in Ephesus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Philad.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Letter of Ignatius to the Church in Philadelphia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Rom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Letter of Ignatius to the Church in Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Smyrn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Letter of Ignatius to the Church in Smyrna")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Irenaeus")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Irenaeus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Adv. haer.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Adversus haereses (Against Heresies)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Justin")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Justin Martyr")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("1 Apol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("First Apology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("2 Apol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Second Apology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Dial.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Dialogue with Trypho the Jew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Mart. Pol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Martyrdom of Polycarp")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Maximus Confessor")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Maximus Confessor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Origen")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Origen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("C. Cels.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Against Celsus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Polycarp")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Polycarp")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Phil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Letter of Polycarp to the Church in Philippi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Sent. Sextus")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Sentences of Sextus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tatian")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tatian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Oratio")]), _vm._v(" ("), _c('em', [_vm._v("Oration")]), _vm._v(" or "), _c('em', [_vm._v("Address")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tertullian")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Tertullian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Apol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Apology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Theophilus of Antioch")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Theophilus of Antioch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Autolycus")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Letter to Autolycus")])])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("IX. GREEK AND ROMAN LITERATURE")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Aristotle")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Aristotle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Rhet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Rhetoric")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Cicero")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Cicero (Marcus Tullius Cicero)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De nat. deor.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De natura deorum (On the Nature of the Gods)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Dionysius of Halicarnassus,")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Dionysius of Halicarnassus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Ant. Rom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Antiquities of Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Epictetus")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Epictetus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Disc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Discourses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Homer")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Homer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('em', [_vm._v("Il.")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Iliad")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Od.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Odyssey")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Juvenal")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Juvenal (Decimus Iunius Iuvenalis)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Lactantius")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Lactantius")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Div. Inst.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Divinarum institutionum (Divine Institutions)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Lucian")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Luciano of Samosata")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Peregr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("The Passing of Peregrinus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Minucius Felix")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Minucius Felix")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Oct.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Octavius")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Pausanias")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Pausanias (Pausanius)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Arcad.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Description of Greece,")]), _vm._v(" bk. 8: "), _c('em', [_vm._v("Arcadia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Plato")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Plato of Athens")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Phaed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Phaedrus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Pliny")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Pliny the Elder")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Hist. Nat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Natural History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Plutarch")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Plutarch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Mor.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Moralia (Morals)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Sera numinis vindicta")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De sera numinis vindicta (On the Delay of Divine Justice)")]), _vm._v(" = "), _c('em', [_vm._v("Moralia")]), _vm._v(" 548-68")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Severus")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Severus Iatrosophista Medicus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("Clyst.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hangl"
  }, [_c('em', [_vm._v("De instrumentis infusoriis seu clysteribus ad Timotheum")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ac41552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0